import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    submit: {
      marginTop: theme.spacing(4),
      width: '100%',
    },
    input: {
      marginTop: theme.spacing(4),
      '& label': {
        paddingBottom: theme.spacing(0.5),
      },
    },
    form: {
      width: '100%',
      margin: theme.spacing(2, 0),
    },
    formWrapper: {
      width: '100%',
    },
    link: {
      marginLeft: theme.spacing(0.5),
      fontWeight: theme.typography.fontWeightBold as 'bold',
    },
    resetPassword: {
      width: '100%',
      textAlign: 'center',
      '& hr': {
        margin: theme.spacing(4, 0),
      },
    },
  })
);
